import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import appConfig from "../../../config/appConfig";
import ShubhamProductDetailsView from "../shared/ShubhamProductDetailsView";

const ShubhamScannedProductPage = () => {
  const [productData, setProductData] = useState(null);
  const [locationData, setLocationData] = useState(null);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const { RSNID } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (RSNID) {
      fetchData(RSNID);
    }
  }, [RSNID]);

  const fetchData = async (rsnId) => {
    setLoading(true);
    setMessage("");
    setProductData(null);
    setLocationData(null);
    setStatus(null);

    try {
      const response = await fetch(`${appConfig.apiBaseUrl}/shubham/showRSNDetails`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ RSNID: rsnId }),
      });
      const result = await response.json();

      if (!result.success || !result.data) {
        setStatus("unauth");
        setMessage("This product is unauthentic.");
        return;
      }

      const data = result.data;
      setProductData({
        productName: data.ProductName,
        batchNumber: data.BatchNo,
        productCode: data.ProductCode,
        batchName: data.UnitCode,
        manufacturingDate: data.MFGDate,
        expiryDate: data.EXPDate,
        mrp: data.MRP,
      });
      setLocationData({
        branchName: data.BranchName,
        street1: data.Location?.Street1,
        street2: data.Location?.Street2,
        street3: data.Location?.Street3,
        street4: data.Location?.Street4,
        street5: data.Location?.Street5,
        street6: data.Location?.Street6,
        state: data.State,
        manufacturedBy: data.ManufacturedBy,
        customerCare: data.CustomerCare,
        fssaiNo: data.FSSAINo,
      });

      if (data.ScannedCount <= 10) {
        setStatus("auth");
      } else {
        setStatus("duplicate");
        setMessage("This product has been scanned multiple times and may be a duplicate.");
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
      setStatus("unauth");
      setMessage("Unable to load product details right now.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <ShubhamProductDetailsView
      productData={productData}
      locationData={locationData}
      status={status}
      loading={loading}
      message={message}
      onBack={() => navigate("/Shubham/locations")}
    />
  );
};

export default ShubhamScannedProductPage;
